module.exports = require('./helpers/bundle-url').getBundleURL('9pgM9') + "bus-tiny.3f63e152.png" + "?" + Date.now();